import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

import { Sizes, Typography } from '@ratehub/base-ui';
import { AmortizationCalculator, CalculatorWidths } from '@ratehub/calculators';

import PAGE_TEMPLATES from '../definitions/PageTemplates';


function BankingAmortizationCalc({
    disclaimer,
    className,
    ...otherProps
}) {
    return (
        <Container className={className}>
            <AmortizationCalculator
                {...otherProps}
            />

            <If condition={disclaimer}>
                <p className={
                    classNames(
                        Typography.CLASSES.TEXT_XS,
                        'disclaimer',
                    )}
                >
                    {disclaimer}
                </p>
            </If>
        </Container>
    );
}

BankingAmortizationCalc.propTypes = {
    disclaimer: PropTypes.string,
    className: PropTypes.string,
};

BankingAmortizationCalc.defaultProps = {
    disclaimer: undefined,
    className: undefined,
};

const Container = styled.section`
    padding: ${Sizes.SPACING.HALF} 0;
    max-width: ${CalculatorWidths.SMALL};
    margin: 0 auto;

    > .disclaimer {
        margin: 0;
        text-align: center;

        padding-top: ${Sizes.SPACING.HALF};
    }
`;

BankingAmortizationCalc.blockKey = 'rh/banking-amortization-calculator';
BankingAmortizationCalc.requiresLayoutRow = true;
BankingAmortizationCalc.hasHeading = false;
BankingAmortizationCalc.supportedPageTypes = [ PAGE_TEMPLATES.calculatorsMtg ];

export default BankingAmortizationCalc;
